document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.connect-button').forEach((btn) => {
      const currentUrl = window.location.href;
      const message = "Hello, I have a question about " + encodeURIComponent(currentUrl);
      const finalUrl = "https://wa.me/917799442578?text=" + message;
      btn.setAttribute('href', finalUrl);
    });
     document.querySelectorAll('.slideshow__slide').forEach((btn) => {
      const currentUrl = window.location.href;
      const message = "Hello, I have a question about " + encodeURIComponent(currentUrl);
      const finalUrl = "https://wa.me/917799442578?text=" + message;
      btn.setAttribute('href', finalUrl);
    });
       document.querySelectorAll('.pdp-clickable-banner').forEach((btn) => {
      const currentUrl = window.location.href;
      const message = "Hello, I have a question about " + encodeURIComponent(currentUrl);
      const finalUrl = "https://wa.me/917799442578?text=" + message;
      btn.setAttribute('href', finalUrl);
    });
});
